import React from 'react';
import { BadgeCheckIcon, StarIcon } from 'lucide-react';
import { Merchant } from '../data/merchants';

/**
 * The seller's mark, name and verification — the same treatment on every
 * sector's card so a shopper learns to read it in one place. Uses the uploaded
 * logo when the merchant has one and a letter-mark when they don't, so the
 * slot is never empty.
 */
export function MerchantBadge({
  merchant,
  variant = 'plain',
  showKind = false
}: {
  merchant: Merchant;
  /** 'frosted' sits on top of a photo; 'plain' sits on the card body. */
  variant?: 'plain' | 'frosted';
  showKind?: boolean;
}) {
  const mark = <span className="w-6 h-6 rounded-md flex items-center justify-center flex-shrink-0 overflow-hidden" style={merchant.logo ? {
    backgroundColor: '#fff'
  } : {
    backgroundColor: merchant.colour
  }} data-id="element-2801" data-mp="213ucwx1wpkyd">
      {merchant.logo ? <img src={merchant.logo} alt="" className="w-full h-full object-contain p-0.5" data-id="element-2802" data-mp="umgymd37oqe7" /> : <span className="text-[10px] font-bold text-white tracking-tight" data-id="element-2803" data-mp="11aaok07a17gg">
          {merchant.initials}
        </span>}
    </span>;
  if (variant === 'frosted') {
    return <span className="inline-flex items-center gap-2 pl-1 pr-2.5 py-1 rounded-full bg-white/95 backdrop-blur-sm shadow-sm max-w-[85%]" data-id="element-2804" data-mp="1aaqq344gm4io">
        {mark}
        <span className="text-[12px] font-bold text-dark-navy truncate" data-id="element-2805" data-mp="1o8p1c0nhhkty">
          {merchant.name}
        </span>
        {merchant.verified && <BadgeCheckIcon className="w-3.5 h-3.5 text-primary-indigo flex-shrink-0" data-id="element-2806" data-mp="1xzs2f2gexzt8" />}
      </span>;
  }
  return <span className="flex items-center gap-2 min-w-0" data-id="element-2807" data-mp="1t2033ndfvbf0">
      {mark}
      <span className="min-w-0" data-id="element-2808" data-mp="27xzhtgv209t4">
        <span className="flex items-center gap-1.5" data-id="element-2809" data-mp="27z0wdvba3efl">
          <span className="text-[12px] font-bold text-dark-navy truncate" data-id="element-2810" data-mp="22z4tjzebht1m">
            {merchant.name}
          </span>
          {merchant.verified && <BadgeCheckIcon className="w-3.5 h-3.5 text-primary-indigo flex-shrink-0" data-id="element-2811" data-mp="2a3xig64z8o0r" />}
        </span>
        {(showKind || merchant.rating) && <span className="flex items-center gap-1.5 text-[11px] text-slate-400 leading-tight" data-id="element-2812" data-mp="2k00klbztwmnp">
            {showKind && merchant.kind && <span className="truncate" data-id="element-2813" data-mp="2ostmzt7triwm">{merchant.kind}</span>}
            {showKind && merchant.kind && merchant.rating && <span data-id="element-2814" data-mp="2tsodvwrlo8ho">·</span>}
            {merchant.rating && <span className="inline-flex items-center gap-0.5 flex-shrink-0" data-id="element-2815" data-mp="2xqm2oyhgkskj">
                <StarIcon className="w-3 h-3 fill-amber-400 text-amber-400" data-id="element-2816" data-mp="32qqjkpma3pba" />
                {merchant.rating}
              </span>}
          </span>}
      </span>
    </span>;
}